import { fetchWrapper } from '../helpers';

export const catalogService = {
  getCategoriesMap,
  getIndustries,
  getLocations,
  getCategoriesRouter,
  getCompanySizes,
  getProjectSizes
};

const baseUrl = `${process.env.BASE_URL}/api/vendor/portfolio`;
const baseUrlAPI = `${process.env.API_BASE_URL}`;

// API
function getCategoriesMap() {
	return fetchWrapper.get(`${baseUrlAPI}/categories/map`);
}

function getIndustries() {
	return fetchWrapper.get(`${baseUrlAPI}/industries`);
}

function getCompanySizes() {
	return fetchWrapper.get(`${baseUrlAPI}/company-size`);
}

function getProjectSizes() {
	return fetchWrapper.get(`${baseUrlAPI}/project-size`);
}

function getLocations() {
	return fetchWrapper.get(`${baseUrlAPI}/locations/country`);
}

function getCategoriesRouter() {
  return fetchWrapper.get(`${baseUrlAPI}/linkage`);
}